import { useTheme } from '@mui/material';
import { ACCOUNT_TYPE_OBJECT, BANK_LIST_OBJECT } from 'app/helpers';
import { normalizeCpfCnpj } from 'app/utils/normalizer';
import { Heading4, TextM } from 'app/components';
import { PixType } from 'modules/customer/context/CustomerProvider/customer.interfaces';
import {
  ReviewSimulationBox,
  ReviewSimulationPreviewItem,
  ReviewSimulationPreviewItems,
  ReviewStepBox,
} from '../styles';
import { ReviewStepSimulationDivider } from './ReviewStepSimulationDivider';
import { BeneficiaryAccount } from '../utils/borrowerTypeParser';

interface ReviewStepBeneficiaryAccountProps {
  beneficiaryAccount: BeneficiaryAccount;
  getFormatedPix: (pixKey?: string, pixType?: PixType) => string;
}

const ReviewStepBeneficiaryAccount = ({
  beneficiaryAccount,
  getFormatedPix,
}: ReviewStepBeneficiaryAccountProps) => {
  const theme = useTheme();

  return (
    <ReviewStepBox marginTop="0px" marginBottom="16px">
      <Heading4
        style={{
          color: theme.palette.brand.secondary.base,
        }}
      >
        Conta Beneficiária
      </Heading4>
      <ReviewSimulationBox>
        <ReviewSimulationPreviewItems>
          <>
            <ReviewSimulationPreviewItem>
              <TextM
                weight="Semibold"
                style={{ color: theme.palette.brand.secondary.base }}
              >
                Descrição
              </TextM>
              <TextM style={{ color: theme.palette.brand.secondary.base }}>
                {beneficiaryAccount.description}
              </TextM>
            </ReviewSimulationPreviewItem>
            <ReviewStepSimulationDivider theme={theme} />
          </>
          <>
            <ReviewSimulationPreviewItem>
              <TextM
                weight="Semibold"
                style={{ color: theme.palette.brand.secondary.base }}
              >
                Nome
              </TextM>
              <TextM style={{ color: theme.palette.brand.secondary.base }}>
                {beneficiaryAccount.holder.name}
              </TextM>
            </ReviewSimulationPreviewItem>
            <ReviewStepSimulationDivider theme={theme} />
          </>
          <>
            <ReviewSimulationPreviewItem>
              <TextM
                weight="Semibold"
                style={{ color: theme.palette.brand.secondary.base }}
              >
                {beneficiaryAccount.holder.taxpayer_id.length > 11
                  ? 'CNPJ'
                  : 'CPF'}
              </TextM>
              <TextM style={{ color: theme.palette.brand.secondary.base }}>
                {normalizeCpfCnpj(beneficiaryAccount.holder.taxpayer_id)}
              </TextM>
            </ReviewSimulationPreviewItem>
            <ReviewStepSimulationDivider theme={theme} />
          </>
          <>
            <ReviewSimulationPreviewItem>
              <TextM
                weight="Semibold"
                style={{ color: theme.palette.brand.secondary.base }}
              >
                Pix
              </TextM>
              <TextM style={{ color: theme.palette.brand.secondary.base }}>
                {beneficiaryAccount.pix
                  ? getFormatedPix(
                      beneficiaryAccount.pix.key,
                      beneficiaryAccount.pix.key_type as PixType,
                    )
                  : '-'}
              </TextM>
            </ReviewSimulationPreviewItem>
            <ReviewStepSimulationDivider theme={theme} />
          </>
        </ReviewSimulationPreviewItems>
        <ReviewSimulationPreviewItems>
          <>
            <ReviewSimulationPreviewItem>
              <TextM
                weight="Semibold"
                style={{ color: theme.palette.brand.secondary.base }}
              >
                Banco
              </TextM>
              <TextM style={{ color: theme.palette.brand.secondary.base }}>
                {beneficiaryAccount.external_bank_account?.ispb_code
                  ? BANK_LIST_OBJECT[
                      beneficiaryAccount.external_bank_account.ispb_code
                    ]
                    ? `${
                        BANK_LIST_OBJECT[
                          beneficiaryAccount.external_bank_account.ispb_code
                        ]
                      } (${beneficiaryAccount.external_bank_account.ispb_code})`
                    : '-'
                  : '-'}
              </TextM>
            </ReviewSimulationPreviewItem>
            <ReviewStepSimulationDivider theme={theme} />
          </>
          <>
            <ReviewSimulationPreviewItem>
              <TextM
                weight="Semibold"
                style={{ color: theme.palette.brand.secondary.base }}
              >
                Conta
              </TextM>
              <TextM style={{ color: theme.palette.brand.secondary.base }}>
                {beneficiaryAccount.external_bank_account?.bank_account
                  ? `${beneficiaryAccount.external_bank_account.bank_account}-${beneficiaryAccount.external_bank_account.bank_account_digit}`
                  : '-'}
              </TextM>
            </ReviewSimulationPreviewItem>
            <ReviewStepSimulationDivider theme={theme} />
          </>
          <>
            <ReviewSimulationPreviewItem>
              <TextM
                weight="Semibold"
                style={{ color: theme.palette.brand.secondary.base }}
              >
                Agência
              </TextM>
              <TextM style={{ color: theme.palette.brand.secondary.base }}>
                {beneficiaryAccount.external_bank_account?.bank_branch || '-'}
              </TextM>
            </ReviewSimulationPreviewItem>
            <ReviewStepSimulationDivider theme={theme} />
          </>
          <>
            <ReviewSimulationPreviewItem>
              <TextM
                weight="Semibold"
                style={{ color: theme.palette.brand.secondary.base }}
              >
                Tipo
              </TextM>
              <TextM style={{ color: theme.palette.brand.secondary.base }}>
                {beneficiaryAccount.external_bank_account?.bank_account_type
                  ? ACCOUNT_TYPE_OBJECT[
                      beneficiaryAccount.external_bank_account.bank_account_type
                    ] ?? '-'
                  : '-'}
              </TextM>
            </ReviewSimulationPreviewItem>
            <ReviewStepSimulationDivider theme={theme} />
          </>
        </ReviewSimulationPreviewItems>
      </ReviewSimulationBox>
    </ReviewStepBox>
  );
};

export default ReviewStepBeneficiaryAccount;
